import { ChargeActions } from '../actions/charges';
import { AnyAction } from 'redux';
import { AUTH_ACTIONS } from '../actions/auth';

const initialState: any = {
  showAddChargeDialog: false,
  selectedTenant: undefined,
};

const chargeReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case ChargeActions.SHOW_ADD_CHARGE_DIALOG: {
      return {
        ...state,
        showAddChargeDialog: action.payload.show,
        selectedTenant: action.payload.selectedTenant,
      };
    }
    case AUTH_ACTIONS.LOGOUT: {
      return initialState;
    }
    default:
      return state;
  }
};

export default chargeReducer;
